import { createFileRoute } from '@tanstack/react-router'
import { Settings } from 'lucide-react'

export const Route = createFileRoute('/master/settings')({
  component: MasterSettingsPage,
})

function MasterSettingsPage() {
  return (
    <div className="max-w-6xl mx-auto space-y-8 animate-fade-in p-6">
      <div className="flex flex-col gap-2">
        <h1 className="text-3xl font-black text-white tracking-tight flex items-center gap-3">
          <Settings className="text-amber-500" size={32} />
          Configurações Globais
        </h1>
        <p className="text-slate-400">
          Gerencie as configurações globais do sistema Master HQ.
        </p>
      </div>

      <div className="bg-slate-900 border border-slate-800 rounded-2xl p-8 flex flex-col items-center justify-center text-center">
        <Settings className="w-16 h-16 text-slate-700 mb-4" />
        <h2 className="text-xl font-bold text-slate-300">Página em Construção</h2>
        <p className="text-slate-500 max-w-md mt-2">
          As configurações globais do sistema Master serão disponibilizadas em breve.
        </p>
      </div>
    </div>
  )
}
